/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the FxIdWebFeaturesAuthCreateTempTokenRequest interface.
 */
export function instanceOfFxIdWebFeaturesAuthCreateTempTokenRequest(value) {
    if (!('RedirectUri' in value) || value['RedirectUri'] === undefined)
        return false;
    return true;
}
export function FxIdWebFeaturesAuthCreateTempTokenRequestFromJSON(json) {
    return FxIdWebFeaturesAuthCreateTempTokenRequestFromJSONTyped(json, false);
}
export function FxIdWebFeaturesAuthCreateTempTokenRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'RedirectUri': json['RedirectUri'],
    };
}
export function FxIdWebFeaturesAuthCreateTempTokenRequestToJSON(json) {
    return FxIdWebFeaturesAuthCreateTempTokenRequestToJSONTyped(json, false);
}
export function FxIdWebFeaturesAuthCreateTempTokenRequestToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'RedirectUri': value['RedirectUri'],
    };
}
//# sourceMappingURL=FxIdWebFeaturesAuthCreateTempTokenRequest.js.map